import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import { Button } from './ui/button';

// Flag SVG Components
const USFlag = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7410 3900" className="h-5 w-7 rounded-sm shadow-sm">
    <rect width="7410" height="3900" fill="#b22234"/>
    <path d="M0,450H7410m0,600H0m0,600H7410m0,600H0m0,600H7410m0,600H0" stroke="#fff" strokeWidth="300"/>
    <rect width="2964" height="2100" fill="#3c3b6e"/>
    <g fill="#fff">
      {[...Array(9)].map((_, row) => 
        [...Array(row % 2 === 0 ? 6 : 5)].map((_, col) => (
          <circle key={`${row}-${col}`} cx={247 + (row % 2 === 0 ? 0 : 247) + col * 494} cy={210 + row * 210} r="80"/>
        ))
      )}
    </g>
  </svg>
);

const DominicanFlag = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 900 600" className="h-5 w-7 rounded-sm shadow-sm">
    {/* Blue quadrant top-left */}
    <rect x="0" y="0" width="400" height="250" fill="#002d62"/>
    {/* Red quadrant top-right */}
    <rect x="500" y="0" width="400" height="250" fill="#ce1126"/>
    {/* Red quadrant bottom-left */}
    <rect x="0" y="350" width="400" height="250" fill="#ce1126"/>
    {/* Blue quadrant bottom-right */}
    <rect x="500" y="350" width="400" height="250" fill="#002d62"/>
    {/* White cross */}
    <rect x="400" y="0" width="100" height="600" fill="#fff"/>
    <rect x="0" y="250" width="900" height="100" fill="#fff"/>
    {/* Simplified coat of arms in center */}
    <circle cx="450" cy="300" r="35" fill="#fff"/>
    <rect x="440" y="275" width="20" height="50" fill="#002d62"/>
    <rect x="435" y="285" width="30" height="8" fill="#ce1126"/>
    <rect x="435" y="305" width="30" height="8" fill="#ce1126"/>
  </svg>
);

const LanguageToggle = () => {
  const { language, toggleLanguage } = useLanguage();

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={toggleLanguage}
      className="flex items-center gap-2 border-gray-300 hover:bg-gray-100 px-2"
      title={language === 'en' ? 'Cambiar a Español' : 'Switch to English'}
    >
      {/* Show current language flag */}
      {language === 'en' ? <USFlag /> : <DominicanFlag />}
      <span className="text-xs font-medium text-gray-600">{language === 'en' ? 'EN' : 'ES'}</span>
    </Button>
  );
};

export default LanguageToggle;
